import * as marietta from '../../..';
import { BUILDING_TYPE_MANSION, CONTROL_ACTIONMODE } from '../../Constants';
import { SVGSprite } from '../../flash/display';
import { Stage } from '../../model';

class RoomCornerDragger {
    viewObj: Element;

    moveFunc: Function;

    moveEndFunc: Function;

    index: number;

    x: number;

    y: number;

    transformMatrix: string;

    public spt: SVGSprite;

    private moveMouseEvent: MouseEvent;

    static selectedIndex:number;

    /**
     * コンストラクタ
     * */
    constructor(targetSprite: SVGSprite, _index: number) {
      this.index = _index;
      // 描画
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
        this.viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        this.viewObj.setAttribute('r', '5');
        this.viewObj.setAttribute('cx', '0');
        this.viewObj.setAttribute('cy', '0');
      } else {
        this.viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        this.viewObj.setAttribute('width', '10');
        this.viewObj.setAttribute('height', '10');
        this.viewObj.setAttribute('x', '-5');
        this.viewObj.setAttribute('y', '-5');
        this.viewObj.setAttribute('stroke', '#3598DC');
        this.viewObj.setAttribute('stroke-width', '1');
      }
      this.viewObj.setAttribute('fill', '#3598DC');
      this.viewObj.setAttribute('id', `itemController_corner_${_index}`);
      this.spt = new SVGSprite(this.viewObj);
      targetSprite.addChild(this.spt);

      // アクション
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
      } else {
        this.viewObj.addEventListener('mousedown', this.onMouseDownMe);
      }
    }

    /**
 * マウスダウンされた
 * @param MouseEvent
 */
    onMouseDownMe = (e: MouseEvent&TouchEvent) => {
      // 選択モードのときは、バブリングさせない
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
        e.preventDefault();
      }
      marietta.webcad.control.parts.RoomCornerDragger.selectedIndex = this.index;
      if (marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerWallObject) {
        if (marietta.webcad.WebCADGlobal.itemManager.itemController.selectedPicker != null) {
          marietta.webcad.WebCADGlobal.itemManager.itemController.selectedPicker.enableDragger();
        }
        marietta.webcad.WebCADGlobal.itemManager.itemController.selectedPicker = this;
      }

      // ドラッグの開始
      e.stopPropagation();
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
        document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
      } else {
        document.addEventListener('mousemove', this.onMouseMoveMe);
        document.addEventListener('mouseup', this.onMouseUpMe);
      }

      const scope: RoomCornerDragger = this;

      // comment k.kubonaka
      // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
      // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
      this.spt.onEnterFrame = (): void => {
        if (scope.moveMouseEvent != null) {
          scope.moveFunc(scope.moveMouseEvent, scope);
        }
      };
      if (marietta.webcad.WebCADGlobal.itemManager.currentItem instanceof marietta.webcad.item.WallObject) {
        this.viewObj.setAttribute('fill', '#eb5e00');
        this.viewObj.setAttribute('stroke', '#eb5e00');
      }
    }

    /**
     * マウスが移動した
     */
    onMouseMoveMe = (e: MouseEvent&TouchEvent) => {
      const self:RoomCornerDragger = this; // 現在の場所

      // pad スマホ用タッチ座標修正
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        if (e.touches.length >= 2) {
          // self.deleteMe();
          self.onMouseUpMe(e);
          return;
        }

        e.preventDefault();
        Stage.refreshStageMouse(<any>e);
      }

      self.moveMouseEvent = e;
    }

    /**
     * マウスがUPされた
     */
    onMouseUpMe = (e: MouseEvent&TouchEvent) => {
      e.preventDefault();
      this.spt.deleteEnterFrame();
      this.moveMouseEvent = null;

      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        document.removeEventListener('touchmove', this.onMouseMoveMe);
        document.removeEventListener('touchend', this.onMouseUpMe);
      } else {
        document.removeEventListener('mousemove', this.onMouseMoveMe);
        document.removeEventListener('mouseup', this.onMouseUpMe);
      }

      // 終了の処理
      this.moveEndFunc(e, this);

      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * 移動 XY
     */
    move(x: number, y: number) {
      this.x = x;
      this.y = y;
      this.updateTranslate();
    }

    /**
    * 移動X
    */
    moveX(x: number) {
      this.x = x;
      this.updateTranslate();
    }

    /**
    * 移動Y
    */
    moveY(y: number) {
      this.y = y;
      this.updateTranslate();
    }

    /**
     * Translateのアップデート
     */
    updateTranslate() {
      // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      let sc: number = 1 / root.scaleX;

      // iPad・スマホは掴みやすくする
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        sc *= 2; // 2倍の大きさにする
      }

      this.transformMatrix = `matrix(${sc},0,0,${sc},${this.x},${this.y})`;
      this.spt.element.setAttribute('transform', this.transformMatrix);
    }

    //--------------------------------
    // モバイル用移動軸対応
    originalPosition: marietta.core.Point;

    /**
    * 元位置の保持
    */
    saveOriginalPoisition() {
      this.originalPosition = new marietta.core.Point(this.x, this.y);
    }

    /**
     * ピッカーdiable
     */
    disableDragger() {
      this.viewObj.setAttribute('fill', '#cccccc');
      this.viewObj.setAttribute('stroke', '#FFFFFF');
    }

    /**
     * ピッカーenable
     */
    enableDragger() {
      this.viewObj.setAttribute('fill', '#3598DC');
      this.viewObj.setAttribute('stroke', '#3598DC');
    }
}
export default RoomCornerDragger;
